export const VaccinationCategory = {
  RABIES: "RABIES",
  OTHER: "OTHER",
}
